import "./index.css";
import {useSetting} from "../../../contexts/setting";
import {useImages} from "../../../contexts/images";
import BgTransformer from "../../../layout/BgTransformer";
import adsAssets from "../../../data/ads-assets.json";

/**
 * InstagramStoriesDevecoAds — 1440×2560 vertical Stories ad. Figma source:
 * 1429:841. Bg-only — no editable text and no bubble (the Figma frame has
 * an empty partner-logo placeholder that we treat as a design artifact and
 * skip per user direction). Mirrors RedditThumb2Ads's bg-only structure.
 */
const InstagramStoriesDevecoAds = ({id, zoom}) => {
  const {channel, product, type, bgOption, locked} = useSetting();
  const {customBgs} = useImages();
  const isLocked = locked.some((x) => x === id);
  const customBgUrl = (isLocked ? customBgs[id] : undefined) || customBgs.main || null;

  const bgIdx = bgOption || 1;
  const assetKey = `${channel.value}/${product.value}/${type.value}/${bgIdx}/${id}`;
  const bgUrl = adsAssets[assetKey]?.url;

  return (
    <div id={id} className={`template ${type.value} tpl-card`} style={{"--zoom-level": zoom}}>
      <div className="tpl-card__inner">
        {customBgUrl || bgUrl ? <BgTransformer src={customBgUrl || bgUrl} id={id} /> : null}
      </div>
    </div>
  );
};

export default InstagramStoriesDevecoAds;
